/* Emerald Quiz Popup v2 (2026-10-11, Ivy): system-first result, Founders/trial/waitlist removed, all answers to Klaviyo, anonymous tracking. Copy fix: no energy-drink comparison; guide promise = 9-point supplement checklist. 5s timing unchanged. */
(function () {
  "use strict";

  if (window.Shopify && window.Shopify.designMode) return;
  var path = window.location.pathname || "";
  if (/\/pages\/find-your-greens\/?$/.test(path)) return;

  var STORAGE_CAPTURED = "eqp_captured";
  var STORAGE_DISMISSED = "eqp_dismissed_at";
  var DISMISS_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
  var POPUP_DELAY_MS = 5000; // flat 5s time-delay trigger, all devices
  var QUIZ_VERSION = "popup_v2";
  var PV = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  var DEVICE = window.innerWidth < 768 ? "mobile" : "desktop";

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  if (storageGet(STORAGE_CAPTURED)) return;
  var dismissedAt = storageGet(STORAGE_DISMISSED);
  if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < DISMISS_SNOOZE_MS) return;

  var UTM = "utm_source=quiz_popup&utm_medium=onsite&utm_campaign=find_your_emerald";
  var CONFIG = {
    WEBHOOK: "https://emeraldio.app.n8n.cloud/webhook/emerald-quiz-capture",
    EVENTS: "https://emeraldio.app.n8n.cloud/webhook/emerald-popup-event",
    SYSTEM_BUILDER: "https://emerald-nutrition.com/pages/the-system?" + UTM + "#bundle",
    PINEAPPLE_PDP:
      "https://emerald-nutrition.com/products/emerald-nutrition-supergreens?variant=54775290953996&" + UTM,
    MANGO_PDP:
      "https://emerald-nutrition.com/products/emerald-nutrition-supergreens?variant=54775290986764&" + UTM,
    IGNITE_PDP: "https://emerald-nutrition.com/products/emerald-nutrition-ignite?" + UTM,
  };

  var Q = [
    {
      key: "need",
      q: "What's your day asking for?",
      opts: [
        ["calm", "A calm, consistent morning routine"],
        ["flavour", "A flavour I'll look forward to, every morning"],
        ["ignite", "Fuel for demanding days — every ingredient disclosed"],
        ["system", "Both — the full daily system"],
      ],
    },
    {
      key: "flavour",
      q: "Pick your flavour energy.",
      opts: [
        ["mango", "Bright & tropical 🥭"],
        ["pineapple", "Crisp & classic 🍍"],
        ["both", "Surprise me — show both"],
      ],
    },
    {
      key: "how",
      q: "How would you like to take your scoop?",
      opts: [
        ["water", "Straight in water"],
        ["smoothie", "In a smoothie"],
        ["go", "On the go"],
      ],
    },
    {
      key: "values",
      q: "What matters most to you?",
      opts: [
        ["transparency", "Knowing exactly what's in it — every ingredient disclosed, no hidden blends"],
        ["taste", "Taste"],
        ["clean", "Clean ingredients, no junk"],
        ["research", "Research-backed"],
      ],
    },
    {
      key: "buy",
      q: "How do you like to buy?",
      opts: [
        ["sub", "Subscribe & save (best value)"],
        ["once", "Try once first"],
      ],
    },
  ];

  var answers = {};
  var step = 0;
  var opened = false;
  var everShown = false;
  var reopenDismissedThisSession = false;
  var openTrigger = "auto";

  var backdrop = document.getElementById("eqp-backdrop");
  var closeBtn = document.getElementById("eqp-close");
  var stage = document.getElementById("eqp-stage");
  var barFill = document.getElementById("eqp-bar-fill");
  var backBtn = document.getElementById("eqp-back");
  var reopenTab = document.getElementById("eqp-reopen");
  var reopenOpenBtn = document.getElementById("eqp-reopen-open");
  var reopenDismissBtn = document.getElementById("eqp-reopen-dismiss");

  if (!backdrop || !stage) return; // snippet not present on this render for some reason

  function esc(s) {
    return (s || "").replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function track(name, props) {
    var data = { quiz: "find_your_greens_popup", quiz_version: QUIZ_VERSION, page: path };
    if (props) {
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) data[k] = props[k];
      }
    }
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: "eqp_" + name };
      for (var d in data) {
        if (Object.prototype.hasOwnProperty.call(data, d)) dl[d] = data[d];
      }
      window.dataLayer.push(dl);
    } catch (e) {}
    try {
      fetch(CONFIG.EVENTS, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          event: name,
          quiz_version: QUIZ_VERSION,
          pv: PV,
          device: DEVICE,
          page: path,
          step: data.step || data.at_step || 0,
          question: data.question || "",
          answer: data.answer || "",
          trigger: data.trigger || "",
          reason: data.reason || "",
          result: data.result || "",
          cta: data.cta || "",
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  function setBar() {
    barFill.style.width = Math.min(100, (step / (Q.length + 1)) * 100) + "%";
  }

  function render() {
    setBar();
    backBtn.style.display = step === 0 || step > Q.length ? "none" : "block";
    if (step < Q.length) renderQuestion(Q[step]);
    else if (step === Q.length) renderEmail();
    else renderResult();
  }

  function renderQuestion(item) {
    stage.innerHTML =
      '<div class="eqp-q">' +
      esc(item.q) +
      '</div><div class="eqp-opts">' +
      item.opts
        .map(function (o) {
          return '<button type="button" class="eqp-opt" data-v="' + o[0] + '">' + esc(o[1]) + "</button>";
        })
        .join("") +
      "</div>";
    stage.querySelectorAll(".eqp-opt").forEach(function (b) {
      b.onclick = function () {
        answers[item.key] = b.dataset.v;
        track("answer", { question: item.key, answer: b.dataset.v, step: step + 1 });
        step++;
        render();
      };
    });
  }

  function captureLead() {
    var a = answers;
    try {
      fetch(CONFIG.WEBHOOK, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          email: a.email,
          ignite: false,
          interest: a.need || "",
          need: a.need || "",
          flavour: a.flavour || "",
          how: a.how || "",
          values: a.values || "",
          buy: a.buy || "",
          source: "popup",
          quiz_version: QUIZ_VERSION,
          page: path,
        }),
      }).catch(function () {});
    } catch (e) {}
    storageSet(STORAGE_CAPTURED, "1");
    track("lead", {
      need: a.need || "",
      flavour: a.flavour || "",
      how: a.how || "",
      values: a.values || "",
      buy: a.buy || "",
    });
    hideReopenTab();
  }

  function renderEmail() {
    track("email_view", { step: Q.length + 1 });
    stage.innerHTML =
      '<div class="eqp-q">Where should we send your result?</div><div class="eqp-sub">Plus your nutritionist\'s 9-point supplement checklist: the test for any supplement.</div><input class="eqp-field" id="eqp-email" type="email" placeholder="you@email.com"><label class="eqp-consent"><input type="checkbox" id="eqp-consent"><span>Yes, email me my result and occasional Emerald updates. Unsubscribe anytime. See our <a href="/policies/privacy-policy" target="_blank" rel="noopener">privacy policy</a>.</span></label><button type="button" class="eqp-btn" id="eqp-go" disabled>See my result →</button>';
    var email = stage.querySelector("#eqp-email"),
      consent = stage.querySelector("#eqp-consent"),
      go = stage.querySelector("#eqp-go");
    function check() {
      go.disabled = !(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value) && consent.checked);
    }
    email.oninput = check;
    consent.onchange = check;
    go.onclick = function () {
      answers.email = email.value.trim();
      captureLead();
      step++;
      render();
    };
  }

  function valuesLine(v) {
    if (v === "transparency") return "Every ingredient is disclosed on our product and ingredients pages, with no proprietary blends.";
    if (v === "taste") return "Same formula in either flavour, so pick the one you'll look forward to.";
    if (v === "clean") return "UK-made, with every ingredient disclosed on our product and ingredients pages.";
    if (v === "research") return "Developed with academic links to De Montfort University.";
    return "";
  }

  function howLine(h) {
    if (h === "water") return "One scoop in water is all it takes.";
    if (h === "smoothie") return "It blends straight into your smoothie.";
    if (h === "go") return "Shake it in a bottle: easy on the go.";
    return "";
  }

  function renderResult() {
    var a = answers;
    var need = a.need || "calm";
    var fl = a.flavour === "both" ? "both" : a.flavour || "pineapple";
    var flavName, flavPdp;
    if (fl === "mango") {
      flavName = "Mango";
      flavPdp = CONFIG.MANGO_PDP;
    } else if (fl === "pineapple") {
      flavName = "Pineapple";
      flavPdp = CONFIG.PINEAPPLE_PDP;
    } else {
      flavName = "";
      flavPdp = CONFIG.PINEAPPLE_PDP;
    }
    var supergreensName = flavName ? flavName + " Supergreens" : "Supergreens";
    var withIgnite = need === "ignite" || need === "system";

    var title = withIgnite ? "Supergreens + Ignite" : supergreensName;
    var lead = withIgnite
      ? "A daily foundation every morning, plus fuel for demanding days."
      : "Your daily foundation. Add Ignite on demanding days and you have the full Emerald system.";

    var extras = [valuesLine(a.values), howLine(a.how)].filter(Boolean).join(" ");
    var buyLine =
      a.buy === "once"
        ? "Choose a one-time purchase or a subscription in the builder."
        : "Choose subscribe &amp; save or a one-time purchase in the builder.";

    var secondaryHref, secondaryLabel, secondaryId;
    if (need === "ignite") {
      secondaryHref = CONFIG.IGNITE_PDP;
      secondaryLabel = "Just want Ignite? Go straight to it →";
      secondaryId = "ignite_pdp";
    } else {
      secondaryHref = flavPdp;
      secondaryLabel = "Just want " + supergreensName + "? Go straight to it →";
      secondaryId = "supergreens_pdp";
    }

    stage.innerHTML =
      '<div class="eqp-result"><span class="eqp-pill">Your starting point</span><h2>' +
      esc(title) +
      '</h2><p class="eqp-muted">' +
      esc(lead) +
      "</p><ul><li><strong>Supergreens</strong> — the daily foundation: one scoop, every morning.</li><li><strong>Ignite</strong> — fuel for demanding days, layered on top, never instead.</li></ul>" +
      (extras ? '<p class="eqp-muted">' + esc(extras) + "</p>" : "") +
      '<a class="eqp-btn" id="eqp-cta-primary" href="' +
      CONFIG.SYSTEM_BUILDER +
      '">Build your routine →</a><p class="eqp-muted" style="margin-top:8px">' +
      buyLine +
      '</p><p style="margin-top:12px;text-align:center"><a id="eqp-cta-secondary" href="' +
      secondaryHref +
      '" style="font-size:14px;text-decoration:underline;color:inherit;opacity:.75">' +
      esc(secondaryLabel) +
      '</a></p><p class="eqp-muted" style="margin-top:16px">Check your inbox — your nutritionist\'s 9-point supplement checklist is on its way. 💚</p></div>';

    var primary = stage.querySelector("#eqp-cta-primary");
    var secondary = stage.querySelector("#eqp-cta-secondary");
    if (primary)
      primary.addEventListener("click", function () {
        track("cta_click", { cta: "primary", destination: "system_builder", need: need });
      });
    if (secondary)
      secondary.addEventListener("click", function () {
        track("cta_click", { cta: "secondary", destination: secondaryId, need: need });
      });
    track("result_view", { result: withIgnite ? "system" : "supergreens_led", need: need, flavour: fl });
    barFill.style.width = "100%";
  }

  backBtn.onclick = function () {
    if (step > 0) {
      step--;
      render();
    }
  };

  function showReopenTab() {
    if (!reopenTab || reopenDismissedThisSession || storageGet(STORAGE_CAPTURED)) return;
    reopenTab.hidden = false;
    requestAnimationFrame(function () {
      reopenTab.classList.add("eqp-reopen-visible");
    });
  }

  function hideReopenTab() {
    if (!reopenTab) return;
    reopenTab.classList.remove("eqp-reopen-visible");
    setTimeout(function () {
      reopenTab.hidden = true;
    }, 250);
  }

  if (reopenOpenBtn) {
    reopenOpenBtn.addEventListener("click", function () {
      hideReopenTab();
      openTrigger = "reopen_tab";
      openPopup();
    });
  }
  if (reopenDismissBtn) {
    reopenDismissBtn.addEventListener("click", function () {
      reopenDismissedThisSession = true;
      hideReopenTab();
    });
  }

  function openPopup() {
    if (opened) return;
    opened = true;
    everShown = true;
    hideReopenTab();
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add("eqp-visible");
    });
    step = 0;
    track("open", { trigger: openTrigger });
    render();
    document.addEventListener("keydown", onKeydown);
  }

  function autoOpenPopup() {
    if (everShown) return;
    openTrigger = "auto";
    openPopup();
  }

  function closePopup(remember, reason) {
    track("dismiss", { reason: reason || "unknown", at_step: step });
    backdrop.classList.remove("eqp-visible");
    document.removeEventListener("keydown", onKeydown);
    setTimeout(function () {
      backdrop.hidden = true;
    }, 250);
    if (remember && !storageGet(STORAGE_CAPTURED)) {
      storageSet(STORAGE_DISMISSED, String(Date.now()));
    }
    opened = false;
    showReopenTab();
  }

  function onKeydown(e) {
    if (e.key === "Escape") closePopup(true, "escape");
  }

  closeBtn.addEventListener("click", function () {
    closePopup(true, "close_button");
  });
  backdrop.addEventListener("click", function (e) {
    if (e.target === backdrop) closePopup(true, "backdrop");
  });

  setTimeout(autoOpenPopup, POPUP_DELAY_MS);
})();